<template>
  <v-btn
    icon
    elevation="0"
    @click="toggleSidebar"
    color="primary"
  >
    <v-icon>{{ mini_sidebar ? 'mdi-menu' : 'mdi-menu-open' }}</v-icon>
  </v-btn>
</template>

<script>

import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["mini_sidebar"]),
  },
  methods: {
    ...mapMutations(["SET_MINI_SIDEBAR"]),
    toggleSidebar() {
      this.SET_MINI_SIDEBAR(!this.mini_sidebar);
    },
  },
};
</script>

<style scoped>
/* Add any necessary styles */
</style>
